import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify'; // Import react-toastify
import 'react-toastify/dist/ReactToastify.css'; // Import react-toastify styles
import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";
import adoptionImage01 from "../../assets/images/registration/adoption/step-1.png";
import adoptionImage02 from "../../assets/images/registration/adoption/step-2.png";
import adoptionImage03 from "../../assets/images/registration/adoption/step-3.png";
import adoptionImage04 from "../../assets/images/registration/adoption/step-4.png";
import adoptionImage05 from "../../assets/images/registration/adoption/step-5.png";
import adoptionImage06 from "../../assets/images/registration/adoption/step-6.png";
import surrogacyImage01 from "../../assets/images/registration/surrogacy/step-1.png";
import surrogacyImage02 from "../../assets/images/registration/surrogacy/step-2.png";
import surrogacyImage03 from "../../assets/images/registration/surrogacy/step-3.png";
import surrogacyImage04 from "../../assets/images/registration/surrogacy/step-4.png";
import surrogacyImage05 from "../../assets/images/registration/surrogacy/step-5.png";
import surrogacyImage06 from "../../assets/images/registration/surrogacy/step-6.png";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Pronouns from './Pronouns';
import Relationship from './Relationship';
import HealthPlan from './Healthplans';
import Gender from './Gender';
import FamilyBuildingGoals from './Family_Building_Goals';
import FamilyBuildingJourney from './Family_Building_Journey';
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import { Endpoints } from "../../Global/Endpoints";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/images/logo-win.svg";
import highmarkLogo from "../../assets/images/highmark/ffb-logo.jpg";
import { setFullyVerified } from '../../Redux/verificationReducer';
import { updateEmail } from '../../Redux/emailReducer';
import { setRegistrationData } from '../../Redux/registrationReducer';
import { updateUserData } from '../../Redux/userReducer';
import { useTranslation } from 'react-i18next';
import PregnancyDueDate from "./PregnancyDueDate";
import PrepregnancyDetails from "./prePregnancyDetails";
import HowToGetPregnant from "./How_to_Get_Pregnant";
import WelcomeKit from "../WINBenifits/WelcomeKit";
import FamilyBuildingAdoptionJourney from "./FamilyBuildingSupport/Adoption/Adoption_Journey_step_1";
import FamilyBuildingAdoptionType from "./FamilyBuildingSupport/Adoption/Adoption_Journey_step_2";
import FamilyBuildingAdoptionAgency from "./FamilyBuildingSupport/Adoption/Adoption_Journey_step_3";
import FamilyBuildingAdoptionSupport from "./FamilyBuildingSupport/Adoption/Adoption_Journey_step_4";
import FamilyBuildingAdoptionTimeline from "./FamilyBuildingSupport/Adoption/Adoption_Journey_step_5";
import FamilyBuildingAdoptionInfo from "./FamilyBuildingSupport/Adoption/Adoption_Journey_step_6";
import FamilyBuildingSurrogacyJourney from "./FamilyBuildingSupport/Surrogacy/Surrogacy_Journey_step_1";
import FamilyBuildingSurrogacyRole from "./FamilyBuildingSupport/Surrogacy/Surrogacy_Journey_step_2";
import FamilyBuildingSurrogacyAgency from "./FamilyBuildingSupport/Surrogacy/Surrogacy_Journey_step_3";
import FamilyBuildingSurrogacySupport from "./FamilyBuildingSupport/Surrogacy/Surrogacy_Journey_step_4";
import FamilyBuildingSurrogacySources from "./FamilyBuildingSupport/Surrogacy/Surrogacy_Journey_step_5";
import FamilyBuildingSurrogacyInfo from "./FamilyBuildingSupport/Surrogacy/Surrogacy_Journey_step_6";

const HealthProfileMultiStageForm = ({ isEditMode }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const cookies = new Cookies();
    const isJourneyChange = useSelector((state) => state.userData.isJourneyChange)
    const [step, setStep] = useState(() => {
      return isJourneyChange && isEditMode ? 4 : 1;
    });
    const isPartiallyVerified = useSelector((state) => state.verification.isPartiallyVerified); // Get partial verification state
    const [verifyData, setVerifyData] = useState({});
    const [editUserData, setEditUserData] = useState({});
    const contract = useSelector((state) => state.userData);
    const [isSubmitting, setIsSubmitting] = useState(false); // Track submission state
    const [errors, setErrors] = useState({});
    const [heightInFeet, setHeightInFeet] = useState("");
    const [heightInInches, setHeightInInches] = useState("");
    const [currentSelectedPlan, setCurrentSelectedPlan] = useState("");
    const [selectedGoal, setSelectedGoal] = useState("");
    const isSSO = useSelector((state) => state.sso.isSSO); 
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const ssoId = useSelector((state) => state.ssoQueryParamsDetails.ssoId);
    const ssoParams = useSelector((state) => state.ssoQueryParamsDetails.ssoParams);
    const isJourneyChangeEdit = isEditMode && isJourneyChange;
    const email = location.state ? location.state?.updatedFormData?.EmailID : contract?.userData?.EmailID;
    const [formData, setFormData] = useState({
        emailId: verifyData?.EmailID,
        pronouns: '',
        relationshipStatus: '',
        healthPlans: [],
        assignedSex: '',
        familyGoals: [],
        journeyStage: '',
        AdoptionJourney: '',
        AdoptionType: '',
        AdoptionAgency: '',
        AdoptionSupport: [],
        AdoptionTimeline: '',
        AdoptionCountry: '',
        SurrogacyJourney: '',
        SurrogacyDescribe: '',
        SurrogacyAgency: '',
        SurrogacySupport: [],
        SurrogacyDonor: '',
        SurrogacyGeography: '',
        password: verifyData?.PWD,
        PregnancyDueDate:"",
        WinCentivekit:"N",
        WinCentiveAddress:"",
        NoDueDateFlag:"",
        IsPregnant:"",
        Weight:"",
        TypeofWeigh:"",
        Height:"",
        TypeofHeight:"",
        Ava:"",
        Mira:"",
        WINFertilityTracker:"",
        Natural:"",
        FertilityTreatment:"",
        DeviceType:""
    });

    const adoptionDefaults = {
        AdoptionJourney: "",
        AdoptionType: "",
        AdoptionAgency: "",
        AdoptionSupport: [],
        AdoptionTimeline: "",
        AdoptionCountry: ""
    };

    const surrogacyDefaults = {
        SurrogacyJourney: "",
        SurrogacyDescribe: "",
        SurrogacyAgency: "",
        SurrogacySupport: [],
        SurrogacyDonor: "",
        SurrogacyGeography: ""
    };

    const getPrimarySelection = (value) => Array.isArray(value) ? value[0] : value;

    const getResetFormData = (nextData) => {
      const nextPlan = getPrimarySelection(nextData.healthPlans);
      const nextGoal = getPrimarySelection(nextData.familyGoals);
      let sanitizedData = { ...nextData };

      if (nextPlan !== 'I want family-building support') {
        sanitizedData = {
          ...sanitizedData,
          familyGoals: [],
          journeyStage: "",
          ...adoptionDefaults,
          ...surrogacyDefaults
        };
      } else {
        if (nextGoal !== "Adoption") {
          sanitizedData = {
            ...sanitizedData,
            ...adoptionDefaults
          };
        }

        if (nextGoal !== "Surrogacy") {
          sanitizedData = {
            ...sanitizedData,
            ...surrogacyDefaults
          };
        }

        if (["Adoption", "Surrogacy"].includes(nextGoal)) {
          sanitizedData = {
            ...sanitizedData,
            journeyStage: ""
          };
        }
      }

      return sanitizedData;
    };

    useEffect(() => {
        const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
        if (myCarousel) {
            new window.bootstrap.Carousel(myCarousel, {
                interval: 2000,
            });
        }
    }, []);

    useEffect(() => {
      if (location.state?.isNavigatingFromCompany) {
        blockOnBackNavigation();
      }
    }, [location.state?.isNavigatingFromCompany]);

    useEffect(() => {
        localStorage.removeItem("isJourneyChange");
    }, [])

    const blockOnBackNavigation = () => {
      const handlePopState = () => {
        window.history.pushState(null, "", window.location.href);
      };

      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopState);

      // Return cleanup
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    };

    useEffect(() => {
        if (!isPartiallyVerified && isEditMode === false) {
            navigate("/login");
        } else if (location.state && !isEditMode) {
            if(location.state?.isNavigatingFromCompany)
          {
            setVerifyData(location.state.updatedFormData);
        } 
        else{
          setVerifyData(location.state.updatedFormData)
        }
        } 
        else if(isJourneyChange && isEditMode)
        {
            fetchExistingProfileData();
            setStep(4);
        } else if (isEditMode) {
            fetchExistingProfileData();
        }
    }, [isPartiallyVerified, location.state, navigate, verifyData, isJourneyChange]);

    useEffect(() => {
      if (!isEditMode) return;

      setStep(isJourneyChange ? 4 : 1);
    }, [isJourneyChange, isEditMode]);

    useEffect(() => {
      const selectedPlan = Array.isArray(formData.healthPlans)
          ? formData.healthPlans[0]
          : formData.healthPlans;
      setCurrentSelectedPlan(selectedPlan);
    }, [formData])

    const normalizeStringArray = (value) => {
      if (Array.isArray(value)) {
        return value.map((item) => String(item).trim()).filter((item) => item !== "");
      }

      if (typeof value === "string") {
        return value.split(",").map((item) => item.trim()).filter((item) => item !== "");
      }

      return [];
    };

    const buildLatestUserData = (apiUserData) => {
      const getApiOrFallback = (key, fallback = "") =>
        Object.prototype.hasOwnProperty.call(apiUserData, key) ? apiUserData[key] : fallback;

      return {
        ...apiUserData,
        Pronouns: getApiOrFallback("Pronouns", formData.pronouns || ""),
        RelationshipStatus: getApiOrFallback("RelationshipStatus", formData.relationshipStatus || ""),
        Gender: getApiOrFallback("Gender", formData.assignedSex || ""),
        WhyHere: getApiOrFallback(
          "WhyHere",
          Array.isArray(formData.healthPlans)
            ? formData.healthPlans.join(", ")
            : formData.healthPlans || ""
        ),
        Goal: getApiOrFallback(
          "Goal",
          formData.familyGoals.length > 0 ? formData.familyGoals.join(", ") : ""
        ),
        JourneyStatus: getApiOrFallback("JourneyStatus", formData.journeyStage || ""),
        AdoptionJourney: getApiOrFallback("AdoptionJourney", formData.AdoptionJourney || ""),
        AdoptionType: getApiOrFallback(
          "AdoptionType",
          Array.isArray(formData.AdoptionType)
            ? formData.AdoptionType.join(", ")
            : formData.AdoptionType || ""
        ),
        AdoptionAgency: getApiOrFallback("AdoptionAgency", formData.AdoptionAgency || ""),
        AdoptionSupport: getApiOrFallback(
          "AdoptionSupport",
          Array.isArray(formData.AdoptionSupport)
            ? formData.AdoptionSupport.join(", ")
            : formData.AdoptionSupport || ""
        ),
        AdoptionTimeline: getApiOrFallback("AdoptionTimeline", formData.AdoptionTimeline || ""),
        AdoptionCountry: getApiOrFallback("AdoptionCountry", formData.AdoptionCountry || ""),
        SurrogacyJourney: getApiOrFallback("SurrogacyJourney", formData.SurrogacyJourney || ""),
        SurrogacyDescribe: getApiOrFallback("SurrogacyDescribe", formData.SurrogacyDescribe || ""),
        SurrogacyAgency: getApiOrFallback("SurrogacyAgency", formData.SurrogacyAgency || ""),
        SurrogacySupport: getApiOrFallback(
          "SurrogacySupport",
          Array.isArray(formData.SurrogacySupport)
            ? formData.SurrogacySupport.join(", ")
            : formData.SurrogacySupport || ""
        ),
        SurrogacyDonor: getApiOrFallback("SurrogacyDonor", formData.SurrogacyDonor || ""),
        SurrogacyGeography: getApiOrFallback("SurrogacyGeography", formData.SurrogacyGeography || ""),
        PregnancyDueDate: getApiOrFallback("PregnancyDueDate", formData.PregnancyDueDate || ""),
        LastMenstrualPeriodDate: getApiOrFallback("LastMenstrualPeriodDate", formData.LastMenstrualPeriodDate || ""),
        IsPregnant: getApiOrFallback("IsPregnant", formData.IsPregnant || ""),
        WinCentivekit: getApiOrFallback("WinCentivekit", formData.WinCentivekit || "N"),
        WinCentiveAddress: getApiOrFallback("WinCentiveAddress", formData.WinCentiveAddress || ""),
        NoDueDateFlag: getApiOrFallback("NoDueDateFlag", formData.NoDueDateFlag || ""),
        Weight: getApiOrFallback("Weight", formData.Weight || ""),
        TypeofWeigh: getApiOrFallback("TypeofWeigh", formData.TypeofWeigh || ""),
        Height: getApiOrFallback("Height", formData.Height || ""),
        TypeofHeight: getApiOrFallback("TypeofHeight", formData.TypeofHeight || ""),
        Ava: getApiOrFallback("Ava", formData.Ava || "N"),
        Mira: getApiOrFallback("Mira", formData.Mira || "N"),
        WINFertilityTracker: getApiOrFallback("WINFertilityTracker", formData.WINFertilityTracker || "N"),
        Natural: getApiOrFallback("Natural", formData.Natural || "N"),
        FertilityTreatment: getApiOrFallback("FertilityTreatment", formData.FertilityTreatment || "N"),
      };
    };

    const validateStep = () => {
        let newErrors = {};
        if (step === 1 && !formData.pronouns) newErrors.pronouns = "Please select your pronouns.";
        if (step === 2 && !formData.relationshipStatus) newErrors.relationshipStatus = "Please select your relationship status.";
        if (step === 3 && !formData.assignedSex) newErrors.assignedSex = "Please select your gender.";
        if (step === 4 && formData.healthPlans.length===0) newErrors.healthPlans = "Please select at least one health plan.";
        if (step === 5 && formData.familyGoals.length === 0) newErrors.familyGoals = "Please select at least one family goal.";
        if (step === 6 && !formData.journeyStage) newErrors.journeyStage = "Please select your journey stage.";
        if (step === 11 && !formData.AdoptionJourney) newErrors.AdoptionJourney = "Please select an adoption journey option.";
        if (step === 12 && normalizeStringArray(formData.AdoptionType).length === 0) newErrors.AdoptionType = "Please select an adoption type.";
        if (step === 13 && !formData.AdoptionAgency) newErrors.AdoptionAgency = "Please select an adoption agency option.";
        if (step === 14 && normalizeStringArray(formData.AdoptionSupport).length === 0) newErrors.AdoptionSupport = "Please select at least one adoption support option.";
        if (step === 17 && !formData.SurrogacyJourney) newErrors.SurrogacyJourney = "Please select a surrogacy journey option.";
        if (step === 18 && !formData.SurrogacyDescribe) newErrors.SurrogacyDescribe = "Please select your surrogacy role.";
        if (step === 19 && !formData.SurrogacyAgency) newErrors.SurrogacyAgency = "Please select a surrogacy agency option.";
        if (step === 20 && normalizeStringArray(formData.SurrogacySupport).length === 0) newErrors.SurrogacySupport = "Please select at least one surrogacy support option.";
        if (step === 8) {
            if (!formData.PregnancyDueDate && !formData.LastMenstrualPeriodDate) 
                newErrors.pregnancyDueDate = "Please select a Due Date or Last Menstruation Date.";
              if(formData.IsPregnant=="")
              { 
                  newErrors.pregnancyType="Please select atleast one option."

        }}
        if(step===9)
        {
          if (formData.enrolled === "Y") {
              if (!formData.addressOption) {
                  newErrors.addressOption = "Please select an address option.";
              }
  
              if (formData.addressOption === "No" && !formData.WinCentiveAddress && !formData.WinCentiveAddress!="") {
                  newErrors.WinCentiveAddress = "Address is required if 'No' is selected.";
              }
          }
        }
        if (step === 10)
        {
          if (formData.TypeofHeight != "cm" && (!heightInFeet || !heightInInches)) {
            newErrors.Height = "Please select both feet and inches to complete your height.";
          }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (value) {
                delete newErrors[name]; // Remove the error from state
            }
           
            return newErrors;
        });
    };

    const handleHealthPlanChange = (value) => {
      setFormData((prevData) => getResetFormData({
        ...prevData,
        healthPlans: value
      }));

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.healthPlans;
        delete newErrors.familyGoals;
        delete newErrors.journeyStage;
        delete newErrors.AdoptionJourney;
        delete newErrors.AdoptionType;
        delete newErrors.AdoptionAgency;
        delete newErrors.AdoptionSupport;
        delete newErrors.SurrogacyJourney;
        delete newErrors.SurrogacyDescribe;
        delete newErrors.SurrogacyAgency;
        delete newErrors.SurrogacySupport;
        return newErrors;
      });
    };

    const handleFamilyGoalChange = (value) => {
      setFormData((prevData) => getResetFormData({
        ...prevData,
        familyGoals: [value]
      }));

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors.familyGoals;
        delete newErrors.journeyStage;
        delete newErrors.AdoptionJourney;
        delete newErrors.AdoptionType;
        delete newErrors.AdoptionAgency;
        delete newErrors.AdoptionSupport;
        delete newErrors.SurrogacyJourney;
        delete newErrors.SurrogacyDescribe;
        delete newErrors.SurrogacyAgency;
        delete newErrors.SurrogacySupport;
        return newErrors;
      });
    };

    const nextStep = () => {
        if(validateStep())
        {
        const goal = Array.isArray(formData.familyGoals) ? formData.familyGoals[0] : formData.familyGoals;
        setSelectedGoal(goal);
        if (formData.healthPlans === 'I want family-building support') {
            if (step === 4) {
              setStep(5);
            } else if (step === 5) {
              if (goal === "Adoption") {
                setStep(11);
              } else if (goal === "Surrogacy") {
                setStep(17);
              } else {
                setStep(6);
              }
            } else if (step === 11) {
              setStep(12);
            } else if (step === 12) {
              setStep(13);
            } else if (step === 13) {
              setStep(14);
            } else if (step === 14) {
              setStep(15);
            } else if (step === 15) {
              setStep(16);
            } else if (step === 17) {
              setStep(18);
            } else if (step === 18) {
              setStep(19);
            } else if (step === 19) {
              setStep(20);
            } else if (step === 20) {
              setStep(21);
            } else if (step === 21) {
              setStep(22);
            }
        } else if((step === 4 &&  formData.healthPlans===t('pregnancysupport')))
            {
              if(formData.entrolled==="Y")
              {
              setStep(8);
              }
              else{
              setStep(7);
              }
                
        }
        else if (step === 4) {
            setStep(6);
        } 
         else if(step===9)
        {
            setStep(10);
        }
            else {
            setStep(step + 1);
        }
    }
    };

    const prevStep = () => {   
        if (isJourneyChange && step === 4) {
            navigate("/home");  // Redirect back to home if isJourneyChange is true
        } else if (step === 7) {
            setStep(4);  // Ensure step 7 goes back to step 4 (Health Plans)
        } 
        else if(step===10)
        {
          if(formData.entrolled==="Y")
          {
            setStep(9);
          } 
          else{
            setStep(8);
          }
        } else if (step === 11 || step === 17) {
          setStep(5);
        }
        else {
            setStep(step - 1);  // Default behavior for normal navigation
        }
    };

    const getTotalSteps = () => {
        const selectedPlan = Array.isArray(formData.healthPlans)
          ? formData.healthPlans[0]
          : formData.healthPlans;
        const selectedGoalValue = Array.isArray(formData.familyGoals)
          ? formData.familyGoals[0]
          : formData.familyGoals;
      
        // 1. Journey edit mode
      if (isJourneyChangeEdit) {
        if (selectedPlan === t('pregnancysupport')) {
          return 4;
        } else if (selectedPlan === 'I want family-building support') {
          return 9;
        } else {
          return 1;
        }
      }
      
        // 2. Edit mode
        if (isEditMode) {
          if (selectedPlan === t('pregnancysupport')) return 7;
          if (selectedPlan === 'I want family-building support') return 12;
          return 4;
        }
      
        // 3. Non-edit (new registration)
        if (selectedPlan === 'I want family-building support') {
          if (["Adoption", "Surrogacy"].includes(selectedGoalValue)) {
            return 11;
          }

          return 6;
        }
        if (selectedPlan === t('pregnancysupport')) return 7;
      
        return 4; // fallback for others
    };
      
    const getCurrentStepNumber = () => {
      const selectedPlan = Array.isArray(formData.healthPlans) ? formData.healthPlans[0] : formData.healthPlans;
      const selectedGoalValue = Array.isArray(formData.familyGoals) ? formData.familyGoals[0] : formData.familyGoals;
    
      if (!isJourneyChangeEdit)
          {
            if (selectedPlan === t('pregnancysupport'))
            {
                if (step === 4) return 4;
                if (step === 7) return 5;
                if (step === 8) return 6;
                if(formData.entrolled==="Y")
                  {
                    if (step === 9) return 7;
                  if (step === 10) return 8;

                  }
                  else{
                    if (step === 10) return 7;
                  }
            }
            if (selectedPlan === 'I want family-building support') {
              if (step <= 5) return step;
              if (step === 6) return 6;
              if (["Adoption", "Surrogacy"].includes(selectedGoalValue)) {
                if (step === 11 || step === 17) return 6;
                if (step === 12 || step === 18) return 7;
                if (step === 13 || step === 19) return 8;
                if (step === 14 || step === 20) return 9;
                if (step === 15 || step === 21) return 10;
                if (step === 16 || step === 22) return 11;
              }
            }
          return step;
        }
      // Edit starts from step 4
      if (selectedPlan === 'I want family-building support') {
        // Steps: 4 → 1, 5 → 2, 6 → 3
        if (step === 4) return 1;
        if (step === 5) return 2;
        if (step === 6) return 3;
        if (step === 11 || step === 17) return 4;
        if (step === 12 || step === 18) return 5;
        if (step === 13 || step === 19) return 6;
        if (step === 14 || step === 20) return 7;
        if (step === 15 || step === 21) return 8;
        if (step === 16 || step === 22) return 9;        
      }
    
      if (selectedPlan === t('pregnancysupport')) {
        // Steps: 4 → 1, 7 → 2, 8 → 3
        if (step === 4) return 1;
        if (step === 7) return 2;
        if (step === 8) return 3;
        if (step === 9) return 4;
          if (step === 10) return 4;
      }
    
      // Default journeyChangeEdit (e.g., step 4 only)
      return 1;
    };
    
    const fetchExistingProfileData = async () => {
      console.log("contract.userData: ", contract.userData)
        setEditUserData(contract.userData);
        setFormData((prevData) => ({
            ...prevData,
            pronouns: contract.userData.Pronouns || "",
            relationshipStatus: contract.userData.RelationshipStatus || "",
            assignedSex: contract.userData.Gender || "",
            healthPlans: Array.isArray(contract.userData.WhyHere)
            ? contract.userData.WhyHere.filter((item) => item.trim() !== "I'm here to learn")
            : contract.userData.WhyHere
            ? contract.userData.WhyHere.split(',')
                .map((item) => item.trim())
                .filter((item) => item !== "" && item !== "I'm here to learn")
            : [],
            familyGoals: Array.isArray(contract.userData.Goal)
                ? contract.userData.Goal
                : contract.userData.Goal
                ? contract.userData.Goal.split(',').map((item) => item.trim()).filter((item) => item !== "")
                : [],
            journeyStage: contract.userData.JourneyStatus || "",
            AdoptionJourney: contract.userData.AdoptionJourney || "",
            AdoptionType: contract.userData.AdoptionType || "",
            AdoptionAgency: contract.userData.AdoptionAgency || "",
            AdoptionSupport: normalizeStringArray(contract.userData.AdoptionSupport),
            AdoptionTimeline: contract.userData.AdoptionTimeline || "",
            AdoptionCountry: contract.userData.AdoptionCountry || "",
            SurrogacyJourney: contract.userData.SurrogacyJourney || "",
            SurrogacyDescribe: contract.userData.SurrogacyDescribe || "",
            SurrogacyAgency: contract.userData.SurrogacyAgency || "",
            SurrogacySupport: normalizeStringArray(contract.userData.SurrogacySupport),
            SurrogacyDonor: contract.userData.SurrogacyDonor || "",
            SurrogacyGeography: contract.userData.SurrogacyGeography || ""
        }));
    };

    const getJourneyImage = (step) => {
      let image = "";
      switch (step) {
        case 11:
          image = adoptionImage01;
          break;

        case 12:
          image = adoptionImage02;
          break;

        case 13:
          image = adoptionImage03;
          break;

        case 14:
          image = adoptionImage04;
          break;

        case 15:
          image = adoptionImage05;
          break;

        case 16:
          image = adoptionImage06
          break;
        
        case 17:
          image = surrogacyImage01;
          break;

        case 18:
          image = surrogacyImage02;
          break;

        case 19:
          image = surrogacyImage03;
          break;

        case 20:
          image = surrogacyImage04;
          break;

        case 21:
          image = surrogacyImage05;
          break;

        case 22:
          image = surrogacyImage06
          break;
      
        default:
          image = adoptionImage01;
          break;
      }

      return image;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return; // Prevent multiple submissions
        if (!validateStep()) return;
        setIsSubmitting(true); // Set submitting state to true
        const params = {
            Company: "",
            Country: "",
            MemberID: "",
            WhyHere: "",
            EmailID: "",
            Language: "",
            Version: "10.8",
            WINBenefits: "",
            LastName: "",
            ZipCode: "",
            Promocode: "",
            Pronouns: "",
            UpdateFlag: "",
            PWD: "",
            JourneyStatus: "",
            HealthPlanId: "",
            PreferredName: "",
            RelationshipStatus: "",
            IsHealthProfileCompleted: 1,
            BenefitProvider: "",
            SubscriberID: "",
            Gender: "",
            Contract: "",
            DOB: "",
            AppLanguage: "English",
            DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            PhoneNo: "",
            Ethnicity: "",
            SecureCode: "",
            Goal: "",
            CountryCode: "",
            TextNotificationStatus: "",
            FirstName: "",
            PregnancyDueDate:"",
            WinCentivekit:"N",
            WinCentiveAddress:"",
            NoDueDateFlag:"",
            LastMenstrualPeriodDate:"",
            IsPregnant:"",
            Weight:"",
            TypeofWeigh:"",
            Height:"",
            TypeofHeight:"",
            AdoptionJourney: "",
            AdoptionType: "",
            AdoptionAgency: "",
            AdoptionSupport: "",
            AdoptionTimeline: "",
            AdoptionCountry: "",
            SurrogacyJourney: "",
            SurrogacyDescribe: "",
            SurrogacyAgency: "",
            SurrogacySupport: "",
            SurrogacyDonor: "",
            SurrogacyGeography: ""
        };
        if (step >= 1) {
            params.EmailID = isEditMode ? editUserData.EmailID || "" : verifyData.EmailID || "";
            params.Pronouns = formData.pronouns || "";
            params.RelationshipStatus = formData.relationshipStatus || "";
        }
        if (step >= 2) {
            params.Gender = formData.assignedSex || "";
        }
        if (step >= 3) {
            params.WhyHere = Array.isArray(formData.healthPlans) ? formData.healthPlans.join(", ") : formData.healthPlans || "";
        }
        if (step >= 5) {
            params.Goal = formData.familyGoals.join(', ') || "";
        }
        if (step >= 6) {
            params.JourneyStatus = t(formData.journeyStage) || "";
        }
        if (step >= 11) {
            params.AdoptionJourney = formData.AdoptionJourney || "";
        }
        if (step >= 12) {
            params.AdoptionType = Array.isArray(formData.AdoptionType) ? formData.AdoptionType.join(', ') : formData.AdoptionType || "";
        }
        if (step >= 13) {
            params.AdoptionAgency = formData.AdoptionAgency || "";
        }
        if (step >= 14) {
            params.AdoptionSupport = Array.isArray(formData.AdoptionSupport) ? formData.AdoptionSupport.join(', ') : formData.AdoptionSupport || "";
        }
        if (step >= 15) {
            params.AdoptionTimeline = formData.AdoptionTimeline || "";
        }
        if (step >= 16) {
            params.AdoptionCountry = formData.AdoptionCountry || "";
        }
        if (step >= 17) {
            params.SurrogacyJourney = formData.SurrogacyJourney || "";
        }
        if (step >= 18) {
            params.SurrogacyDescribe = formData.SurrogacyDescribe || "";
        }
        if (step >= 19) {
            params.SurrogacyAgency = formData.SurrogacyAgency || "";
        }
        if (step >= 20) {
            params.SurrogacySupport = Array.isArray(formData.SurrogacySupport) ? formData.SurrogacySupport.join(', ') : formData.SurrogacySupport || "";
        }
        if (step >= 21) {
            params.SurrogacyDonor = formData.SurrogacyDonor || "";
        }
        if (step >= 22) {
            params.SurrogacyGeography = formData.SurrogacyGeography || "";
        }
        if (step >= 7) {
            
            params.WinCentivekit = formData.WinCentivekit || "";
            params.IsPregnant=formData.IsPregnant||"";
            params.NoDueDateFlag=formData.NoDueDateFlag ||"";
            params.LastMenstrualPeriodDate=formData.LastMenstrualPeriodDate ||""
        }
        if(step>=8)
        {
            params.PregnancyDueDate = formData.PregnancyDueDate || "";
            params.WinCentiveAddress = formData.WinCentiveAddress || "";
        }
        if(step>=9)
        {
            params.Weight=formData.Weight
            params.TypeofWeigh=formData.TypeofWeigh
            params.Height=formData.Height
            params.TypeofHeight=formData.TypeofHeight
        }
        if (formData.BabyCount) {
          debugger
            params.BabyCount = formData.BabyCount;
        }

        if (isEditMode) {
            params.Country = editUserData.Country || "";
            params.MemberID = editUserData.MemberID || "";
            params.Language = editUserData.Language || "";
            params.Contract = editUserData.Contract || editUserData.ContractIdentified || "";
            params.WINBenefits = "Y";
            params.LastName = editUserData.LastName || "";
            params.ZipCode = editUserData.ZipCode || "";
            params.Promocode = editUserData.Promocode || editUserData.EmployerCode;
            params.UpdateFlag = "Y";
            params.PWD = editUserData.PWD || "";
            params.PreferredName = editUserData.PreferredName || "";
            params.BenefitProvider = editUserData.BenefitProvider || "";
            params.Contract = editUserData.Contract || editUserData.ContractIdentified || "";
            params.DOB = editUserData.DOB || "";
            params.DeviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
            params.PhoneNo = editUserData.PhoneNo || editUserData.MobileNumber || "";
            params.Ethnicity = editUserData.Ethnicity || "";
            params.SecureCode = editUserData.SecureCode || "";
            params.CountryCode = editUserData.CountryCode || "";
            params.TextNotificationStatus = editUserData.TextNotificationStatus || "";
            params.FirstName = editUserData.FirstName || "";
        } else {
            params.Company = verifyData.Company || "";
            params.Country = verifyData.Country || "";
            params.MemberID = verifyData.MemberID || "";
            params.Language = verifyData.Language || "";
            params.WINBenefits = verifyData.WINBenefits || "N";
            params.LastName = verifyData.LastName || "";
            params.ZipCode = verifyData.ZipCode || "";
            params.Promocode = verifyData.Promocode || "";
            params.UpdateFlag = verifyData.UpdateFlag || "N";
            params.PWD = verifyData.PWD || "";
            params.PreferredName = verifyData.PreferredName || "";
            params.HealthPlanId = verifyData.HealthPlanId || "";
            params.SubscriberID = verifyData.SubscriberID || "";
            params.Contract = verifyData.Contract || verifyData.ContractIdentified || "";
            params.DOB = verifyData.DOB || "";
            params.DeviceType =  isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
            params.PhoneNo = verifyData.PhoneNo || verifyData.MobileNumber || "";
            params.Ethnicity = verifyData.Ethnicity || "";
            params.SecureCode = verifyData.SecureCode || "";
            params.CountryCode = verifyData.CountryCode || "";
            params.TextNotificationStatus = verifyData.TextNotificationStatus || "N";
            params.FirstName = verifyData.FirstName || "";
        }

        try {
          const paramsObject ={
            ...params,
                EmployeeID: "",
                EmployeeFirstName: "",
                EmployeeLastName: "",
                RelationshiptoEmployee: ""
          }

            const selectedPlan = getPrimarySelection(formData.healthPlans);
            if (selectedPlan === t('pregnancysupport')) {
                await SavepreconceptionDetails();
            }

            const response = await axios.post(
                Endpoints.CreateAccount,
                `_Params=${encodeURIComponent(JSON.stringify(paramsObject))}`,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    }
                }
            );
            if (response.data.Result === 2) {
                const latestUserData = buildLatestUserData(response.data);
                const Ethnicity = latestUserData.Ethnicity;
                const WhyHere = latestUserData.WhyHere;

                    if (isEditMode) {
                        dispatch(updateEmail(editUserData.EmailID));
                        dispatch(setRegistrationData(latestUserData));
                        dispatch(updateUserData(latestUserData));
                          setEditUserData(latestUserData);
                          setFormData((prevData) => ({
                            ...prevData,
                            pronouns: latestUserData.Pronouns || "",
                            relationshipStatus: latestUserData.RelationshipStatus || "",
                            assignedSex: latestUserData.Gender || "",
                            healthPlans: Array.isArray(latestUserData.WhyHere) ? latestUserData.WhyHere : latestUserData.WhyHere ? latestUserData.WhyHere.split(',').map((item) => item.trim()).filter((item) => item !== "") : [],
                            familyGoals: Array.isArray(latestUserData.Goal) ? latestUserData.Goal : latestUserData.Goal ? latestUserData.Goal.split(',').map((item) => item.trim()).filter((item) => item !== "") : [],
                            journeyStage: latestUserData.JourneyStatus || "",
                            AdoptionJourney: latestUserData.AdoptionJourney || "",
                            AdoptionType: latestUserData.AdoptionType || "",
                            AdoptionAgency: latestUserData.AdoptionAgency || "",
                            AdoptionSupport: normalizeStringArray(latestUserData.AdoptionSupport),
                            AdoptionTimeline: latestUserData.AdoptionTimeline || "",
                            AdoptionCountry: latestUserData.AdoptionCountry || "",
                            SurrogacyJourney: latestUserData.SurrogacyJourney || "",
                            SurrogacyDescribe: latestUserData.SurrogacyDescribe || "",
                            SurrogacyAgency: latestUserData.SurrogacyAgency || "",
                            SurrogacySupport: normalizeStringArray(latestUserData.SurrogacySupport),
                            SurrogacyDonor: latestUserData.SurrogacyDonor || "",
                            SurrogacyGeography: latestUserData.SurrogacyGeography || ""
                          }));
                        
                        toast.success(t('profileupdatedsucessfully'), { autoClose: 5000 });
                         }
                         if (!isEditMode) {
                          console.log("Creating account for new user...", ssoId, ssoParams);                            // Fetch the token only in non-edit mode
                            let token = isSSO ? await validateSSOUser(ssoId, ssoParams) : await getTokenId(); 
                            console.log("Token after validation:", token);
                            debugger
                            if (token) {
                              console.log("Obtained Token:", token);
                                // Set token in cookies and localStorage
                                cookies.set('AccessToken', token, { path: '/' });
                                localStorage.setItem('AccessToken', token);
                                
                                // Initialize session expiration
                                const expirationTime = Date.now() + 15 * 60 * 1000; // 15 minutes
                                localStorage.setItem('sessionExpiration', expirationTime.toString());
                                localStorage.removeItem('sessionExpired'); // Clear any existing expired flag
                                
                                // Update Redux state
                                dispatch({ type: 'LOGIN_SUCCESS', payload: token });
                                dispatch(setFullyVerified());
                                dispatch(setRegistrationData(latestUserData));
                                dispatch(updateUserData(latestUserData));
                                dispatch(updateEmail(verifyData.EmailID));
                                setVerifyData(latestUserData);
                            }
                            toast.success(t('profilesavedsucessfully'), { autoClose: 5000 });
                        }
                            // Reset header menu state before navigating home
                    window.dispatchEvent(new Event("resetHeaderMenu"));
                    setTimeout(() => {
                        navigate(
                          !isEditMode ? 
                          "/welcome" : "/home", { state: { Ethnicity, WhyHere } }
                        );
                    }, 3000);
            } else if (response.data.Result === 0) {
              navigate("/registration-error");
            } else {
                toast.error(`Account creation failed: ${response.data.Message || "Unknown error"}`, { autoClose: 2000 });
            }
        } catch (error) {
            toast.error(`Error creating account: ${error.response?.data?.Message || error.message}`, { autoClose: 2000 });
            setIsSubmitting(false);
          }
    };
 
    const SavepreconceptionDetails = async () => {
        try {
            const params = {
                Emailid: isEditMode ? editUserData.EmailID || "" : verifyData.EmailID || "",
                Ava: formData.Ava || 'N',
                Mira: formData.Mira || 'N',
                WINFertilityTracker: formData.WINFertilityTracker || 'N',
                Natural: formData.Natural || 'N',
                FertilityTreatment: formData.FertilityTreatment || 'N',
                DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
            };

            const response = await axios.post(
                Endpoints.SavePreconception,
                `_Params=${encodeURIComponent(JSON.stringify(params))}`,
                {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
            );
            if (response.status === 200) {
                console.log(response.data);
                return;
            }
        } catch (error) {
            toast.error(`Error saving preconception: ${error.response?.data?.Message || error.message}`, { autoClose: 2000 });
            setIsSubmitting(false);
            return;
        }
    };

    const validateSSOUser = async (ssoId, ssoParams) => {
      console.log("Validating SSO user with ID and Params:", ssoId, ssoParams);
      // If ssoId or ssoParams are missing, get them from sessionStorage

      if (!ssoId || !ssoParams) {
        ssoId = sessionStorage.getItem("ssoId");
        ssoParams = sessionStorage.getItem("ssoParams");
      }
    
      debugger
        try {
          const params = {
            SSO_ID: ssoId,
            SSO_PARAMS: ssoParams,
          };
      
          const response = await axios.post(
            Endpoints.ValidateSSO,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
      console.log("SSO Validation Response:", response.data);
      debugger
          if (response.data!=null) {
            const token = response.data?.Token;
            return token;
          }
        } catch (error) {
        }
    };
                    
    const getTokenId = async () => {
        const emailId = verifyData.EmailID;
        try {
            const response = await axios.post(
                Endpoints.GET_Token,
                `Password=${encodeURIComponent(verifyData.PWD)}&UserName=${encodeURIComponent(emailId)}`,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    }
                }
            );

            if (response.data?.Token?.TokenId) {
                const token = response.data.Token.TokenId;
                cookies.set('AccessToken', token, { path: '/' });
                localStorage.setItem('AccessToken', token);
                return token;
            } else {
                toast.error("unable to get the token", { autoClose: 2000 });
            }
        } catch (error) {
            toast.error("unable to get the token", { autoClose: 2000 });
        }
    };

    const isLastStep = step === 16 || step === 22 || (step === 4 && !formData.healthPlans==='I want family-building support') || (step === 4 && !formData.healthPlans===t('pregnancysupport') ||  step === 8 || (step === 6 && formData.healthPlans==='I want family-building support' && !["Adoption", "Surrogacy"].includes(selectedGoal)));
    useEffect(() => {
      const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
      
      if (myCarousel) {
          new window.bootstrap.Carousel(myCarousel, {
            interval: 5000, // Set interval in milliseconds
          });
        }
    }, []);

    return (
        <>
            {!isEditMode && (
                <header>
                    <nav className="navbar navbar-expand-lg container-fixed">
                        <a className="navbar-brand" href="#">
                              {isHighmarkPortal ? 
                                <img src={highmarkLogo} alt="Logo" className="logo brand-logo" />
                              : 
                                <img src={logo} alt="Logo" className="logo brand-logo" />
                              } 
                        </a>
                    </nav>
                </header>
            )}

            <div className="profile-setup-block-main">
                <div className="registration-image-wrapper">
                    { currentSelectedPlan === 'I want family-building support' && step >= 11 ? 
                    <>
                      <div>
                        <img src={getJourneyImage(step)} alt="" className="registration-sub-image" />
                      </div>
                    </> : 
                      <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                                <img src={loginImage01} alt="" className="registration-image" />
                            </div>
                            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                                <img src={loginImage02} alt="" className="registration-image" />
                            </div>
                            <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                                <img src={loginImage03} alt="" className="registration-image" />
                            </div>
                        </div>
                      </div> 
                    }
                </div>

                <div className="registration-form-main">
                    <div className="registration-form">
                        <div className="registration-process-form-wrapper">
                          <form onSubmit={handleSubmit}>
                            {step === 1 && (
                              <Pronouns
                                nextStep={nextStep}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.pronouns}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 2 && (
                              <Relationship
                                nextStep={nextStep}
                                prevStep={prevStep}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.relationshipStatus}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 3 && (
                              <Gender
                                nextStep={nextStep}
                                prevStep={prevStep}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.assignedSex}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 4 && (
                              <HealthPlan
                                nextStep={nextStep}
                                prevStep={prevStep}
                                formData={formData}
                                setFormData={setFormData}
                                handleHealthPlanChange={handleHealthPlanChange}
                                handleSubmit={handleSubmit}
                                isSubmitting={isSubmitting}
                                error={errors.healthPlans}
                                emailid={isEditMode ? editUserData.EmailID : email}
                                setErrors={setErrors}
                                isEdit={isEditMode}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 5 && (
                              <FamilyBuildingGoals
                                nextStep={nextStep}
                                prevStep={prevStep}
                                handleChange={handleChange}
                                handleFamilyGoalChange={handleFamilyGoalChange}
                                formData={formData}
                                error={errors.familyGoals}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 6 && (
                              <FamilyBuildingJourney
                                prevStep={prevStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                isLastStep={isLastStep}
                                isSubmitting={isSubmitting}
                                error={errors.journeyStage}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 8 && (
                              <PregnancyDueDate
                                nextStep={nextStep}
                                prevStep={prevStep}
                                formData={formData}
                                setFormData={setFormData}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                isLastStep={isLastStep}
                                creationData={verifyData}
                                error={errors.pregnancyDueDate || errors.addressOption || errors.WinCentiveAddress || errors.pregnancyType}
                                setErrors={setErrors}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 9 && (
                              <WelcomeKit
                                nextStep={nextStep}
                                prevStep={prevStep}
                                formData={formData}
                                setFormData={setFormData}
                                handleChange={handleChange}
                                handleSubmit={handleSubmit}
                                isLastStep={isLastStep}
                                creationData={verifyData}
                                error={ errors.addressOption || errors.WinCentiveAddress }
                                setErrors={setErrors}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 7 && (
                              <HowToGetPregnant
                                nextStep={nextStep}
                                prevStep={prevStep}
                                formData={formData}
                                setFormData={setFormData}
                                handleChange={handleChange}
                                error={errors}
                                setErrors={setErrors}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 10 && (
                              <PrepregnancyDetails
                                prevStep={prevStep}
                                formData={formData}
                                handleChange={handleChange}
                                setFormData={setFormData}
                                isSubmitting={isSubmitting}
                                isLastStep={isLastStep}
                                handleSubmit={handleSubmit}
                                error={errors}
                                setErrors={setErrors}
                                setHeightInFeet={setHeightInFeet}
                                setHeightInInches={setHeightInInches}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 11 && (
                              <FamilyBuildingAdoptionJourney
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.AdoptionJourney}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 12 && (
                              <FamilyBuildingAdoptionType
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.AdoptionType}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 13 && (
                              <FamilyBuildingAdoptionAgency
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.AdoptionAgency}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 14 && (
                              <FamilyBuildingAdoptionSupport
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.AdoptionSupport}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 15 && (
                              <FamilyBuildingAdoptionTimeline
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.journeyStage}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                             {step === 16 && (
                              <FamilyBuildingAdoptionInfo
                                prevStep={prevStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                isLastStep={isLastStep}
                                isSubmitting={isSubmitting}
                                error={errors.journeyStage}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 17 && (
                              <FamilyBuildingSurrogacyJourney
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.SurrogacyJourney}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 18 && (
                              <FamilyBuildingSurrogacyRole
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.SurrogacyDescribe}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 19 && (
                              <FamilyBuildingSurrogacyAgency
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.SurrogacyAgency}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 20 && (
                              <FamilyBuildingSurrogacySupport
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.SurrogacySupport}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 21 && (
                              <FamilyBuildingSurrogacySources
                                prevStep={prevStep}
                                nextStep={nextStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                error={errors.journeyStage}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                            {step === 22 && (
                              <FamilyBuildingSurrogacyInfo
                                prevStep={prevStep}
                                handleSubmit={handleSubmit}
                                handleChange={handleChange}
                                formData={formData}
                                isLastStep={isLastStep}
                                isSubmitting={isSubmitting}
                                error={errors.journeyStage}
                                step={getCurrentStepNumber()}
                                totalSteps={getTotalSteps()}
                                isHighmarkPortal={isHighmarkPortal}
                              />
                            )}
                          </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer /> {/* For showing toast notifications */}
        </>
    );
};

export default HealthProfileMultiStageForm;
